import * as React from "react";

import { Box, SxProps, Theme } from "@mui/material";

export const Display: React.FunctionComponent<React.PropsWithChildren<{ when: boolean; sx?: SxProps<Theme> }>> = ({
  when,
  children,
  sx,
}) => {
  return (
    <Box
      sx={
        when
          ? { ...sx, maxWidth: "100%", position: "relative", height: "auto" }
          : { ...sx, display: "none", position: "absolute", height: 0 }
      }
      component="span"
    >
      {children}
    </Box>
  );
};
